import React, { FC } from 'react';

interface CommentItemLoadingProps {
  count?: number;
}

export const CommentItemLoading: FC<CommentItemLoadingProps> = ({
  count = 1,
}) => {
  const renderCount = Math.min(count, 4); // max 4 skeletons

  return (
    <>
      {Array.from({ length: renderCount }).map((_, idx) => (
        <div key={idx} className="flex items-start gap-3 mb-4 animate-pulse">
          {/* Avatar Skeleton */}
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gray-200" />

          {/* Content Skeleton */}
          <div className="flex-1 space-y-2">
            {/* Name */}
            <div className="h-3 w-32 bg-gray-200 rounded" />

            {/* Date */}
            <div className="h-3 w-20 bg-gray-200 rounded" />

            {/* Comment */}
            <div className="h-3 bg-gray-200 rounded w-full" />
            <div className="h-3 bg-gray-200 rounded w-5/6" />
          </div>
        </div>
      ))}
    </>
  );
};

export default CommentItemLoading;
